:host {
	font-family: monospace;
}
